import authentication from '../../B2CAuth';
import qs from 'qs';

export default function getConfig(params, data) {
  const token = authentication.getAccessToken();
  
  //const [accessToken] = useState(null);
  const environmentContext = JSON.parse(sessionStorage.getItem('previousEnvironmentContext'));
  const selectedImpersonationUserEmail = environmentContext && environmentContext.selectedImpersonationUserEmail;

  const config = {
    headers: {
      'Authorization': 'Bearer ' + token
//      'Authorization': 'Bearer ' + accessToken
    }
  }

  if (selectedImpersonationUserEmail || params) {
    config.paramsSerializer = {
      //encode: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
      //indexes: null // by default: false
      serialize: (params) => {
          return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  }

  if (selectedImpersonationUserEmail) {
    config.params = {
      impersonateUser: selectedImpersonationUserEmail
    }
  }

  if (params) {
    if (!config.params) {
      config.params = {};
    }

    //config.params = { ...config.params, params };

    for (let key in params) {
      config.params[key] = params[key];
    }  
  }

  if (data) {
    config.data = {}
    if (data instanceof Array) {
      config.data = data;
    } else {
      for (let key in data) {
        config.data[key] = data[key];
      }  
    }
  }
  
  return config;
}
